<template>
  <MyOrdersScratchcardCard v-bind="data">
    <template #header>
      <MyOrdersWinningBadge v-if="data.winningsPayload" />

      <MyOrdersScratchcardStatus
        v-if="data.state === ScratchcardState.Cancelled"
        :status="data.state"
      />
    </template>
  </MyOrdersScratchcardCard>
</template>

<script lang="ts" setup>
import {
  type ScratchcardOrdersQuery,
  ScratchcardState,
} from '#api/shared/@types/generated/backend/graphql-schema-types'

type MyOrdersScratchcardCardPastProps = {
  data: ScratchcardOrdersQuery['scratchcardOrders']['scratchcardOrders'][0]
}

defineProps<MyOrdersScratchcardCardPastProps>()
</script>
